import { Box, Grid } from "@material-ui/core";
import { useContext } from "react";
import PersonalDataComponent from "../../../components/materialui/Shared/PersonalDataComponent";
import AddressDataComponent from "../../../components/materialui/Shared/AddressDataComponent";
import { MedicoParceiroContext } from "../../../../context/MedicoParceiroContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import Controls from "../../../../components/controls/Controls";
import { RegiaoOptions } from "../../../../data/Regiao";

export default function PersonalAddressDataStep() {
  const { state, dispatch } = useContext(MedicoParceiroContext);

  const onInputPersonalChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  const onInputAddressChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  const onRadioGroupChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  return (
    <div>
      <Steps.StepTitle text="Dados Pessoais" />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Controls.RadioGroup
            name="Region"
            label="Região"
            value={state.PersonalAddressDataForm.Region.Value}
            onChange={(e) => {
              onRadioGroupChange(
                "Region",
                state.PersonalAddressDataForm,
                e.target.value
              );
            }}
            items={RegiaoOptions}
            error={state.PersonalAddressDataForm.Region.Error}
          />
        </Grid>
      </Grid>

      <Box mt={2}>
        <PersonalDataComponent
          PersonalDataForm={state.PersonalDataForm}
          onInputChange={onInputPersonalChange}
        />
      </Box>

      <Steps.StepTitle text="Endereço Residencial" />

      <Box mt={4}>
        <AddressDataComponent
          AddressDataForm={state.AddressDataForm}
          onInputChange={onInputAddressChange}
        />
      </Box>
    </div>
  );
}
